import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ScrapeDataDetailViewer from '../../components/admin/scrape/ScrapeDataDetailViewer';

const ScrapeDataDetailView: React.FC = () => {
  return (
    <AdminLayout>
      <ScrapeDataDetailViewer />
    </AdminLayout>
  );
};

export default ScrapeDataDetailView;